module.exports = __webpack_public_path__ + "img/XBS-alt.695aec7f.svg";